import { Tabs } from "antd";
import "./CustomTabs.scss";

const CustomTabs = ({
    items = [],
    activeKey,
    defaultActiveKey,
    onChange,
    type = "line",
    size = "middle",
    centered = false,
    tabBarGutter = 24,
    className = "",
    ...rest
}) => {
    return (
        <div className={`custom-tabs-wrapper ${className}`}>
            <Tabs
                items={items}
                activeKey={activeKey}
                defaultActiveKey={defaultActiveKey}
                onChange={onChange}
                type={type}
                size={size}
                centered={centered}
                tabBarGutter={tabBarGutter}
                {...rest}
            />
        </div>
    );
};

export default CustomTabs;
